import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import Select from 'components/lib/Select';

import { useCompaniesCreateEditModalContext } from './CompaniesCreateEditModalContext';
import { COMPANY_KEYS, SHOPS_PER_YEAR } from './constants';
import { getAvailableMonths } from './utils';

const Container = styled.div`
  margin-bottom: 10px;
`;

const Half = styled.div`
  display: flex;
  flex: 1;
  flexwrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
`;

const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 25px;
  gap: 10px;
`;

const SelectLabel = styled.div`
  font-size: 14px;
  color: var(--text-primary);
`;

const StyledSelect = styled(Select)`
  && .ant-select-selector {
    border-radius: 0; !important;
  }
  && .ant-select-selection-item {
    font-size: 14px; !important;
    color: var(--text-primary); !important;
  }
`;

const CompaniesCreateEditModalContentMysteryShoppingShopsPerYear = () => {
  const { company, handleChange } = useCompaniesCreateEditModalContext();
  const { shops_per_year = SHOPS_PER_YEAR.QUARTERLY, shop_months = [] } = company?.mystery_shop_setting ?? {};

  const showQuarterly = shops_per_year == SHOPS_PER_YEAR.QUARTERLY;

  const [selectedMonths, setSelectedMonths] = useState({
    first: shop_months[0] || null,
    second: shop_months[1] || null,
    third: shop_months[2] || null,
    fourth: shop_months[3] || null,
  });

  useEffect(() => {
    const mystery_shop_setting = { ...company?.mystery_shop_setting };
    mystery_shop_setting.shop_months = Object.values(selectedMonths).reduce<number[]>(
      (acc, value) => (value !== null ? [...acc, value] : acc),
      []
    );

    handleChange(COMPANY_KEYS.MYSTERY_SHOP_SETTING, mystery_shop_setting);
  }, [selectedMonths]);

  useEffect(() => {
    if (!showQuarterly)
      setSelectedMonths({
        first: shop_months[0] || null,
        second: shop_months[1] || null,
        third: null,
        fourth: null,
      });
  }, [showQuarterly]);

  return (
    <Container>
      <Half>
        <SelectContainer>
          <SelectLabel>1st shop</SelectLabel>
          <StyledSelect
            placeholder="Select month"
            options={getAvailableMonths(null)}
            value={selectedMonths.first}
            onChange={(value) => setSelectedMonths({ first: value, second: null, third: null, fourth: null })}
            style={{ height: '36px', width: '130px' }}
          />
        </SelectContainer>
        <SelectContainer>
          <SelectLabel>2nd shop</SelectLabel>
          <StyledSelect
            placeholder="Select month"
            options={getAvailableMonths(selectedMonths.first)}
            value={selectedMonths.second}
            onChange={(value) => setSelectedMonths((prev) => ({ ...prev, second: value, third: null, fourth: null }))}
            style={{ height: '36px', width: '130px' }}
            disabled={!selectedMonths.first}
          />
        </SelectContainer>
      </Half>
      {showQuarterly && (
        <Half>
          <SelectContainer>
            <SelectLabel>3rd shop</SelectLabel>
            <StyledSelect
              placeholder="Select month"
              options={getAvailableMonths(selectedMonths.second)}
              value={selectedMonths.third}
              onChange={(value) => setSelectedMonths((prev) => ({ ...prev, third: value, fourth: null }))}
              style={{ height: '36px', width: '130px' }}
              disabled={!selectedMonths.second}
            />
          </SelectContainer>
          <SelectContainer>
            <SelectLabel>4th shop</SelectLabel>
            <StyledSelect
              placeholder="Select month"
              options={getAvailableMonths(selectedMonths.third)}
              value={selectedMonths.fourth}
              onChange={(value) => setSelectedMonths((prev) => ({ ...prev, fourth: value }))}
              style={{ height: '36px', width: '130px' }}
              disabled={!selectedMonths.third}
            />
          </SelectContainer>
        </Half>
      )}
    </Container>
  );
};

export default CompaniesCreateEditModalContentMysteryShoppingShopsPerYear;
